import { LayoutDataType } from '../../types';

export const INTERACTION_OPTIONS: {
  id: NonNullable<LayoutDataType['interaction']>;
  title: string;
}[] = [
  {
    id: 'deep_connection',
    title: '💖 Deep Connection',
  },
  {
    id: 'friendship',
    title: '✌️ Friendship',
  },
  {
    id: 'casual_chatting',
    title: '💬 Casual Chatting',
  },
  {
    id: 'one_night_stand',
    title: '💦 One night stand',
  },
];

export const SAFE_INTERACTIONS: {
  id: NonNullable<LayoutDataType['interaction']>;
  title: string;
}[] = [
  {
    id: 'deep_connection',
    title: '💖 Deep Connection',
  },
  {
    id: 'friendship',
    title: '✌️ Friendship',
  },
  {
    id: 'casual_chatting',
    title: '💬 Casual Chatting',
  },
];
